import { LOGIN_FORM_SET_PASSWORD, LOGIN_FORM_SET_USERNAME } from '../../constants';

import { createLogger } from 'redux-logger'
import immutableToJS from '../../utils/immutable-to-js';

const logger = createLogger({
  collapsed: true,
  stateTransformer: (state) => {
    return immutableToJS(state);
  },
  predicate: (getState, { type }) => {
    return type != LOGIN_FORM_SET_USERNAME && type != LOGIN_FORM_SET_PASSWORD
  },
});


export default logger;
